export const translations = {
  it: {
    nav: {
      home: "Home",
      properties: "Immobili",
      about: "Chi Siamo",
      contact: "Contatti",
      evaluation: "Valutazione gratuita",
    },
    hero: {
      eyebrow: "Pisa e Provincia • dal 2016",
      title: "La casa dei tuoi sogni\npotrebbe essere qui.",
      subtitle: "Da dieci anni accompagniamo famiglie e investitori nella scelta dell'immobile giusto, tra le colline pisane e il litorale.",
      ctaProperties: "Esplora gli immobili",
      ctaEvaluation: "Valutazione gratuita",
    },
    filters: {
      title: "Trova il tuo immobile",
      contract: "Contratto",
      type: "Tipo immobile",
      zone: "Zona",
      maxPrice: "Prezzo max",
      search: "Cerca",
      anyContract: "Vendita e affitto",
      anyType: "Tutti i tipi",
      anyZone: "Tutte le zone",
      sale: "Vendita",
      rent: "Affitto",
      apartment: "Appartamento",
      villa: "Villa",
      house: "Casa indipendente",
      room: "Stanza",
      commercial: "Commerciale",
      land: "Terreno",
    },
    featured: {
      eyebrow: "Selezione esclusiva",
      title: "Immobili in evidenza",
      subtitle: "Una selezione curata delle opportunità più interessanti del momento a Pisa e dintorni.",
      viewAll: "Vedi tutti gli immobili",
    },
    about: {
      eyebrow: "Chi siamo",
      title: "Dieci anni di esperienza,\nradicata in Toscana.",
      p1: "La Sala Immobiliare nasce nel 2016 dalla passione di Matteo La Sala, che a soli 18 anni ha iniziato a muovere i primi passi nel settore. Negli anni ha costruito esperienza tra Pisa, Viareggio, Lucca, Roma e Milano, imparando a leggere mercati molto diversi e a parlare la lingua di ogni cliente.",
      p2: "Oggi quella stessa cura artigianale è il nostro biglietto da visita: trasparenza, conoscenza profonda del territorio toscano e un approccio umano. Ti aspettiamo nel nostro ufficio in via Livia Gereschi, a Pisa, davanti a un caffè.",
      values: [
        { title: "Trasparenza", text: "Nessuna sorpresa. Documenti chiari, prezzi onesti, comunicazione costante." },
        { title: "Conoscenza locale", text: "Esperienza maturata tra Pisa, Viareggio, Lucca, Roma e Milano." },
        { title: "Cura su misura", text: "Ogni cliente è una persona, ogni casa una storia. Lavoriamo solo così." },
      ],
      cta: "Scopri la nostra storia",
    },
    evaluation: {
      eyebrow: "Vuoi vendere o affittare?",
      title: "Quanto vale davvero il tuo immobile?",
      subtitle: "Richiedi una valutazione gratuita e senza impegno. Un nostro consulente ti contatterà entro 24 ore.",
      cta: "Richiedi valutazione gratuita",
      formTitle: "Valutazione gratuita",
      formSubtitle: "Compila il form, ti ricontattiamo entro 24 ore con una stima trasparente.",
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono",
      propertyType: "Tipo di immobile",
      address: "Indirizzo immobile",
      area: "Superficie (mq)",
      rooms: "Numero di vani",
      notes: "Note aggiuntive",
      submit: "Invia richiesta",
      success: "Richiesta inviata! Ti contatteremo entro 24 ore.",
      error: "Si è verificato un errore. Riprova più tardi.",
    },
    contact: {
      eyebrow: "Parliamo",
      title: "Vieni a trovarci\na Pisa.",
      subtitle: "Il modo migliore per conoscerci è davanti a un caffè nel nostro ufficio in centro.",
      address: "Indirizzo",
      phone: "Telefono",
      email: "Email",
      hours: "Orari di apertura",
      hoursValue: "Lun–Ven 9:00–13:00 / 15:30–19:30\nSab 9:30–12:30",
      formTitle: "Inviaci un messaggio",
      name: "Nome e cognome",
      message: "Messaggio",
      submit: "Invia messaggio",
      success: "Messaggio inviato! Ti risponderemo presto.",
      error: "Si è verificato un errore. Riprova.",
    },
    property: {
      forSale: "In vendita",
      forRent: "In affitto",
      sold: "Venduto",
      rented: "Affittato",
      priceOnRequest: "Prezzo su richiesta",
      rooms: "Vani",
      bedrooms: "Camere",
      bathrooms: "Bagni",
      area: "Superficie",
      energy: "Classe energetica",
      features: "Caratteristiche",
      gallery: "Galleria",
      contactCta: "Richiedi informazioni",
      backToList: "Torna agli immobili",
      noResults: "Nessun immobile corrisponde ai filtri selezionati.",
      from: "da",
      perMonth: "/mese",
    },
    footer: {
      tagline: "La casa dei tuoi sogni potrebbe essere qui.",
      quickLinks: "Link veloci",
      contactInfo: "Contatti",
      legal: "Privacy & Cookie",
      rights: "Tutti i diritti riservati.",
    },
  },
  en: {
    nav: {
      home: "Home",
      properties: "Properties",
      about: "About",
      contact: "Contact",
      evaluation: "Free valuation",
    },
    hero: {
      eyebrow: "Pisa & Province • since 2016",
      title: "Your dream home\ncould be right here.",
      subtitle: "For ten years we have guided families and investors towards the right property, between the Pisan hills and the coast.",
      ctaProperties: "Explore properties",
      ctaEvaluation: "Free valuation",
    },
    filters: {
      title: "Find your property",
      contract: "Contract",
      type: "Property type",
      zone: "Area",
      maxPrice: "Max price",
      search: "Search",
      anyContract: "Sale & rent",
      anyType: "All types",
      anyZone: "All areas",
      sale: "For sale",
      rent: "For rent",
      apartment: "Apartment",
      villa: "Villa",
      house: "Detached house",
      room: "Room",
      commercial: "Commercial",
      land: "Land",
    },
    featured: {
      eyebrow: "Hand-picked",
      title: "Featured properties",
      subtitle: "A curated selection of the most interesting opportunities in Pisa and surroundings.",
      viewAll: "View all properties",
    },
    about: {
      eyebrow: "About us",
      title: "Ten years of experience,\nrooted in Tuscany.",
      p1: "La Sala Immobiliare was founded in 2016 by Matteo La Sala, who started in real estate at just 18. Over the years he has built experience across Pisa, Viareggio, Lucca, Rome and Milan, learning to read very different markets and speak each client's language.",
      p2: "That same craftsman's care is our signature today: transparency, deep knowledge of the Tuscan territory and a human approach. We're waiting for you at our office on via Livia Gereschi, in Pisa, over a coffee.",
      values: [
        { title: "Transparency", text: "No surprises. Clear documents, honest prices, constant communication." },
        { title: "Local expertise", text: "Experience built across Pisa, Viareggio, Lucca, Rome and Milan." },
        { title: "Tailored care", text: "Every client is a person, every home a story. That's the only way we work." },
      ],
      cta: "Discover our story",
    },
    evaluation: {
      eyebrow: "Selling or renting out?",
      title: "How much is your property really worth?",
      subtitle: "Request a free, no-obligation valuation. One of our consultants will contact you within 24 hours.",
      cta: "Request free valuation",
      formTitle: "Free valuation",
      formSubtitle: "Fill in the form, we'll get back to you within 24 hours with a transparent estimate.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      propertyType: "Property type",
      address: "Property address",
      area: "Surface (sqm)",
      rooms: "Number of rooms",
      notes: "Additional notes",
      submit: "Send request",
      success: "Request sent! We'll contact you within 24 hours.",
      error: "An error occurred. Please try again later.",
    },
    contact: {
      eyebrow: "Let's talk",
      title: "Visit us\nin Pisa.",
      subtitle: "The best way to get to know us is over a coffee in our central office.",
      address: "Address",
      phone: "Phone",
      email: "Email",
      hours: "Opening hours",
      hoursValue: "Mon–Fri 9:00–13:00 / 15:30–19:30\nSat 9:30–12:30",
      formTitle: "Send us a message",
      name: "Full name",
      message: "Message",
      submit: "Send message",
      success: "Message sent! We'll get back to you soon.",
      error: "An error occurred. Please try again.",
    },
    property: {
      forSale: "For sale",
      forRent: "For rent",
      sold: "Sold",
      rented: "Rented",
      priceOnRequest: "Price on request",
      rooms: "Rooms",
      bedrooms: "Bedrooms",
      bathrooms: "Bathrooms",
      area: "Surface",
      energy: "Energy class",
      features: "Features",
      gallery: "Gallery",
      contactCta: "Request info",
      backToList: "Back to properties",
      noResults: "No properties match the selected filters.",
      from: "from",
      perMonth: "/month",
    },
    footer: {
      tagline: "Your dream home could be right here.",
      quickLinks: "Quick links",
      contactInfo: "Contact",
      legal: "Privacy & Cookies",
      rights: "All rights reserved.",
    },
  },
};
